import { orderDetailState } from "@/atoms/order/order-detail-state";
import { OrderStatusDisplayNames } from "@/common/enum/order-status";
import { Body14Regular } from "@/components/typography/Body14Regular";
import { Table } from "flowbite-react";
import { useRecoilState } from "recoil";
import { CustomCell } from "../CustomCell";

export const OrderStatusHeaderTable = () => {
  const headCellStyle = "font-medium text-gray-900 bg-gray-100";
  const [orderDetail, setOrderDetail] = useRecoilState(orderDetailState);

  if (!orderDetail) {
    return null;
  }

  return (
    <div className="overflow-x-auto flex flex-col gap-[16px]">
      <div className="rounded-lg border overflow-hidden">
        <Table>
          <Table.Body>
            <Table.Row className="border-b border-gray-200">
              <Table.Cell className={`${headCellStyle} w-[112px] p-0 h-[52px]`}>
                <CustomCell>
                  <Body14Regular className="text-semantic-text-secondary">
                    현재 발주 상태
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
              <Table.Cell className="bg-primary-white">
                <CustomCell>
                  <Body14Regular className="text-semantic-text-body">
                    {OrderStatusDisplayNames[orderDetail.status]}
                  </Body14Regular>
                </CustomCell>
              </Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </div>
    </div>
  );
};
